*** DEV Component ***

<div class="mad-datatable-action-bar">
  <!-- Table actions: displayed before the table -->
  @if (tableActions?.length) {
    <div>
      @for (tableAction of tableActions; track tableAction) {
        <mad-outline-button [disabled]="isDisabled(tableAction.type)" class="table-action" (click)="onTableAction(tableAction)">
          {{ tableAction.label | translate }} {{ getSelectedCount(tableAction.type) }}
        </mad-outline-button>
      }
    </div>
  }
  <!-- Table filter -->
  @if (isFilterEnabled) {
    <mat-form-field>
      <mat-label>{{ filterLabel | translate }}</mat-label>
      <input matInput autocomplete="off" (keyup)="setFilterValue($event?.target?.value)" placeholder="{{ filterPlaceholder }}" />
    </mat-form-field>
  }
</div>

<!-- Row action menu -->
<mat-menu #rowActionMenu="matMenu">
  <ng-template matMenuContent let-element="element">
    @for (rowAction of rowActions; track rowAction) {
      <button mat-menu-item class="row-action" (click)="onRowEvent($event, element, rowAction)">
        {{ rowAction.label | translate }}
      </button>
    }
  </ng-template>
</mat-menu>

<!-- editable definition menu -->
<mat-menu #editableDefinitionMenu="matMenu">
  <ng-template matMenuContent>
    @for (definition of editableColumnDefinitions; track definition) {
      <button
        mat-menu-item
        class="row-action"
        (click)="onColumnSettings(definition)"
        [ngClass]="{ 'active-column-definition': isCurrentDefinition(definition) }"
      >
        {{ definition.label | translate }}
      </button>
    }
  </ng-template>
</mat-menu>

<!-- viewable definition menu -->
<mat-menu #viewableDefinitionMenu="matMenu">
  <ng-template matMenuContent>
    @for (definition of viewableColumnDefinitions; track definition) {
      <button
        mat-menu-item
        class="row-action"
        (click)="onViewDefinition(definition)"
        [ngClass]="{ 'active-column-definition': isCurrentDefinition(definition) }"
      >
        {{ definition.label | translate }}
      </button>
    }
  </ng-template>
</mat-menu>

@if (rowCount > 0) {
  <div class="datatable" [class]="tableClass">
    @if (isLoading) {
      <div class="mad-datatable-spinner-wrapper">
        <mat-spinner [diameter]="50" [strokeWidth]="3"></mat-spinner>
      </div>
    }

    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortingEvent($event)">
      <!-- Row actions column-->
      <ng-container [matColumnDef]="ACTION_COLUMN_NAME">
        <th scope="col" mat-header-cell *matHeaderCellDef class="row-action-button">
          <!-- BATCH: master checkbox -->
          @if (mode === BATCH) {
            <div class="mad-datatable-checkbox-container">
              <mat-checkbox (change)="onToggleSelectAll()" [checked]="allSelected"> </mat-checkbox>
            </div>
          }
          <!-- SINGLE / NONE: nothing in header row -->
        </th>
        <td mat-cell *matCellDef="let element" class="row-action-button">
          <!-- BATCH: row checkbox -->
          @if (mode === BATCH) {
            <div class="mad-datatable-checkbox-container">
              <mat-checkbox (click)="onRowCheckbox($event, element.rowId)" [checked]="isSelected(element.rowId)"> </mat-checkbox>
            </div>
          }
          <!-- SINGLE: row action menu icon -->
          @if (mode === SINGLE) {
            <mad-icon-button [matMenuTriggerData]="{ element: element }" [matMenuTriggerFor]="rowActionMenu">
              <mat-icon>more_vert</mat-icon>
            </mad-icon-button>
          }
          <!-- NONE: nothing -->
        </td>
      </ng-container>
      <!-- Columns with data -->
      @for (column of columns; track column.id) {
        <ng-container [matColumnDef]="column.id">
          @if (column.isSortable) {
            <th
              scope="col"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header="{{ column.orderByName ? column.orderByName : column.dataPropertyName }}"
              [arrowPosition]="column.isRightAligned ? 'before' : 'after'"
              [class.text-right]="column.isRightAligned"
            >
              {{ column.label | translate }}
            </th>
          } @else {
            <th scope="col" mat-header-cell *matHeaderCellDef [class.text-right]="column.isRightAligned">
              {{ column.label | translate }}
            </th>
          }
          <td mat-cell *matCellDef="let element" [class.text-right]="column.isRightAligned">
            @switch (column.transformer) {
              @default {
                <span>
                  {{ element[column.dataPropertyName] }}
                </span>
              }
            }
          </td>
        </ng-container>
      }
      <tr mat-header-row *matHeaderRowDef="columnIds"></tr>
      <tr
        mat-row
        [class.clickable-table-row]="isRowClickable"
        (click)="onRowEvent($event, row)"
        *matRowDef="let row; columns: columnIds"
      ></tr>
    </table>
  </div>
} @else {
  <!-- No data alert -->
  <div class="noDataText">
    @if (isLoading) {
      <div class="mad-datatable-spinner-wrapper">
        <mat-spinner [diameter]="50" [strokeWidth]="3"></mat-spinner>
      </div>
    }
    {{ noDataText }}
  </div>
}
<div class="mad-data-table-bottom-area">
  <div class="mad-data-table-bottom-info-area">
    <!-- column settings: 1 definition -->
    @if (this.editableColumnDefinitions?.length == 1) {
      <mad-icon-button (click)="onColumnSettings()">
        <mat-icon class="material-icons-outlined">view_column</mat-icon>
      </mad-icon-button>
    }
    <!-- column settings: multiple definitions -->
    @if (this.editableColumnDefinitions?.length > 0) {
      <mad-icon-button [matMenuTriggerFor]="editableDefinitionMenu">
        <mat-icon>view_column</mat-icon>
      </mad-icon-button>
    }
    <!-- column view: multiple definitions -->
    @if (this.viewableColumnDefinitions?.length > 0) {
      <mad-icon-button [matMenuTriggerFor]="viewableDefinitionMenu">
        <mat-icon>preview</mat-icon>
      </mad-icon-button>
    }
  </div>

  <!-- Pagination -->
  <mat-paginator
    [style.display]="isPaginationEnabled ? 'block' : 'none'"
    [pageIndex]="paginatorPageIndex"
    [pageSize]="paginatorPageSize"
    [length]="paginatorLength"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPageEvent($event)"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
